import { Col, Row } from 'antd';
import styled from 'styled-components';

import { media } from '../../styles/breakpoints';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 400px;

  .ant-image {
    margin-bottom: 20px;
  }

  ${media.md} {
    max-width: 100%;
    padding: 0 16px;
  }
`;

export const RowStyled = styled(Row)`
  min-height: 100vh;
  overflow: hidden;

  ${media.md} {
    overflow: auto;
  }
`;

export const Center = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 0 20px;
  background: white;

  ${media.md} {
    min-height: 100vh;
    padding: 40px 20px;
    justify-content: flex-start;
    padding-top: 60px;
  }

  ${media.sm} {
    padding: 32px 16px;
    padding-top: 48px;
  }
`;

export const ImageCol = styled(Col)`
  position: relative;

  ${media.md} {
    display: none;
  }
`;

export const Image = styled.div`
  background-image: url(/images/bg.png);
  height: 100vh;
  background-size: cover;
  background-position: center;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(
      135deg,
      rgba(138, 43, 226, 0.85) 0%,
      rgba(75, 0, 130, 0.9) 100%
    );
  }
`;

export const ImageOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 40px;
  color: white;
  text-align: center;
`;

export const WelcomeTitle = styled.h1`
  font-size: 36px;
  font-weight: 700;
  color: white;
  margin: 0 0 12px 0;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
`;

export const WelcomeSubtitle = styled.p`
  font-size: 18px;
  color: rgba(255, 255, 255, 0.9);
  margin: 0 0 48px 0;
  max-width: 400px;
`;

export const FeatureCards = styled.div`
  display: flex;
  gap: 16px;
`;

export const FeatureCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 24px 32px;
  flex: 1;
  min-width: 120px;
  background: rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(10px);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  transition: all 0.2s;

  &:hover {
    background: rgba(255, 255, 255, 0.15);
    transform: translateY(-2px);
  }

  svg {
    width: 32px;
    height: 32px;
    color: white;
  }

  span {
    font-size: 14px;
    font-weight: 500;
    color: white;
  }
`;

export const MobileFooter = styled.div`
  display: none;

  ${media.md} {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    margin-top: auto;
    padding-top: 40px;
    padding-bottom: 24px;
  }
`;

export const PoweredBy = styled.span`
  font-size: 12px;
  color: rgba(0, 0, 0, 0.35);
`;
